export default __webpack_public_path__ + "static/media/money-back.70c239ce.png";